interface ITier {
  startingUnit?: number;
  endingUnit?: number | null;
  price?: number;
}

interface ITierPricing {
  includedUnits?: number | null;
  tiers?: ITier[];
}

function calculateBillableUnits(pricing: ITierPricing, quantity: number): number {
  return Math.max(0, quantity - (pricing.includedUnits || 0));
}

// Mirrors the backend Tiered and Volume price model calculators.
export function calculateTierUnitPrice(model: string | undefined, pricing: ITierPricing, quantity: number): number | undefined {
  if ((model || "").toUpperCase() !== "VOLUME") {
    return undefined;
  }
  const billableUnits = calculateBillableUnits(pricing, quantity);
  if (quantity > 0 && billableUnits === 0) {
    return 0;
  }
  const tiers = pricing.tiers || [];
  let tier = tiers[0];
  for (const t of tiers) {
    if (billableUnits < (t.startingUnit ?? billableUnits)) {
      break;
    }
    tier = t;
  }
  return tier ? tier.price || 0 : 0;
}

export default function calculateTierPrice(model: string | undefined, pricing: ITierPricing, quantity: number): number {
  const unitPrice = calculateTierUnitPrice(model, pricing, quantity);
  if (unitPrice !== undefined) {
    return unitPrice * calculateBillableUnits(pricing, quantity);
  }
  let total = 0;
  (pricing.tiers || []).forEach((t) => {
    const start = t.startingUnit || 0;
    if (quantity >= start) {
      total += (t.price || 0) * (Math.min(quantity, t.endingUnit || Infinity) - (start - 1));
    }
  });
  return total;
}
